<footer class="site-footer">
  <div class="container footer-grid">
    <section>
      <h5>دبیر پسند</h5>
      <ul>
        @for (editor of content.editors; track editor.name + editor.role) {
          <li>{{ editor.role }} — {{ editor.name }}</li>
        }
      </ul>
    </section>

    <section>
      <h5>صارفین</h5>
      <ul>
        @for (item of content.audiences; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </section>

    <section>
      <h5>صارفین ای میل کریں</h5>
      <ul>
        @for (topic of content.mailTopics; track topic) {
          <li>{{ topic }}</li>
        }
      </ul>
    </section>

    <section>
      <h5>رابطہ</h5>
      <ul>
        <li>
          <a [href]="'mailto:' + content.email">{{ content.email }}</a>
        </li>
        <li><a routerLink="/blog">بلاگ</a></li>
        <li><a routerLink="/links">کَڑیاں</a></li>
        <li><a routerLink="/dictionaries">لغات</a></li>
      </ul>
      <a routerLink="/" class="footer-brand">
        <img src="images/logo.png" [alt]="content.brand" width="48" height="48" />
        <span>{{ content.brand }}</span>
      </a>
    </section>
  </div>

  <div class="footer-bottom">
    <div class="container">
      {{ year }} | ویب سائٹ کی ترقی، {{ content.brand }}
    </div>
  </div>
</footer>
